<span class="direction-badge" [ngClass]="styleClass">
    <span class="direction-badge__arrow" aria-hidden="true">{{ presentation.arrow }}</span>
    <span class="direction-badge__text" [class.visually-hidden]="!showText">{{ presentation.text }}</span>
</span>
